export class DifficultyLevel
{
    static readonly E0= 'E0';
    static readonly E1= 'E1';
    static readonly E2= 'E2';
};